<template>
  <v-container style="min-height: calc(100vh - 80px);">
    <v-row>
      <v-col cols="12" md="4">
        <v-autocomplete
          v-model="paramberita.location"
          :items="listlocation"
          label="Location"
          name="daerah"
          prepend-inner-icon="mdi-map-marker">
        </v-autocomplete>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          prepend-inner-icon="search"
          v-model="paramberita.keyword"
          label="Company name"
          name="keyword">
        </v-text-field>
      </v-col>
      <v-col cols="12" md="2">
        <v-btn
          class="mt-1 white--text"
          :color="maincolor"
          type="submit"
          large
          block
          @click="getBeritaFilter">
          <v-icon left>search</v-icon> Search
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="12" v-if="datalist.length > 0">
        <v-row>
          <v-col
            class="d-flex" style="flex-direction:column"
            cols="12"
            sm="6"
            md="6"
            v-for="(com, i) in datalist"
            :key="i">
            <v-card
              class="flex-grow-1"
              rounded="lg"
              outlined
              :style="'border-color: ' + maincolor">
              <v-container>
                <v-row class="pa-3">
                  <v-col cols="12" md="8">
                    <div class="d-flex">
                      <div class="d-inline mr-5">
                        <v-img
                          :lazy-src="require('../assets/default.jpg')"
                          :src="com.urlpic ? com.urlpic : ''"
                          max-height="70"
                          max-width="70">
                        </v-img>
                      </div>
                      <div class="d-inline">
                        <h3 class="text-md-h6 font-weight-bold">
                          <router-link :to="{ name: 'Companydetail', query: { comid: com.com_id } }">
                            {{ com.com_name }}
                          </router-link>
                          <v-tooltip top v-if="com.com_mou === 'yes'">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                right
                                color="success"
                                v-bind="attrs"
                                v-on="on">
                                mdi-check-decagram
                              </v-icon>
                            </template>
                            <span>Verified as PNB Partner</span>
                          </v-tooltip>
                        </h3>
                        <span class="text-subtitle-1">{{ com.com_location ? com.com_location : 'Location' }}</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4" :class="$vuetify.breakpoint.smAndDown ? 'text-left' : 'text-right'">
                    <p class="caption mb-0 font-weight-bold">
                      <v-icon class="mr-1">mdi-update</v-icon>
                      <timeago :datetime="com.com_update"></timeago>
                    </p>
                  </v-col>
                  <v-col cols="12" md="12" class="pt-0">
                    <div class="my-3">
                      <v-chip
                        class="mr-1"
                        color="primary"
                        small
                        dark>
                        <v-icon left small>
                          mdi-account-group
                        </v-icon>
                        {{ com.com_size ? com.com_size : '1' }} employees
                      </v-chip>
                      <v-chip
                        class="mr-1"
                        color="deep-orange"
                        small
                        dark>
                        <v-icon left small>
                          mdi-alarm-light
                        </v-icon>
                        {{ com.jum ? com.jum : 0 }} vacancies
                      </v-chip>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <infinite-loading :identifier="infiniteId" @infinite="getBerita">
          <div slot="spinner">Loading...</div>
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import InfiniteLoading from 'vue-infinite-loading';
import { mapState } from 'vuex';

export default {
  name: 'Company',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      check: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    publickey: '123',
    listlocation: ['BADUNG', 'DENPASAR', 'GIANYAR', 'TABANAN'],
    datalist: [],
    listjenisdata: [],
    listkecamatan: [],
    panduan: null,
    paramberita: {
      keyword: '',
      location: '',
      limit: 20,
      offset: 0,
    },
    filter: {
      location: '',
      jenisdata: '',
      year: [],
      olahraga: '',
      tingkat: '',
      kelamin: '',
      kecamatan: '',
      kelurahan: '',
      gaji: [3, 7],
    },
    check: {
      reference: '',
    },
    formcheck: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
    },
    hasil: {
      headers: [
        { text: 'Tahun', value: 'tahun_prestasi' },
        { text: 'Peringkat', value: 'juara_prestasi' },
        { text: 'Tingkat', value: 'tingkat_prestasi' },
      ],
      data: [],
    },
    infiniteId: +new Date(),
  }),
  mounted() {
    // this.getBeritaFilter();
    if (this.$route.query.reference && this.$route.query.reference !== '') {
      this.check.reference = this.$route.query.reference;
      // this.checkAtletByNik();
    }
  },
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
    ]),
  },
  methods: {
    getBeritaFilter() {
      this.paramberita.offset = 0;
      this.datalist = [];
      this.infiniteId += 1;
    },
    getBerita($state) {
      this.axios
        .get(
          this.api + '/public/company',
          {
            params: this.paramberita,
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              if (resdata.data.length > 0) {
                this.paramberita.offset += this.paramberita.limit;
                resdata.data.forEach((element) => {
                  element.urlpic = this.api + '/upload/avatar/' + element.com_picture;
                  this.datalist.push(element);
                });
                // this.datalist.push(...resdata.data);
                if (this.datalist.length < this.paramberita.offset) {
                  $state.complete();
                } else {
                  $state.loaded();
                }
              } else {
                $state.complete();
              }
            }
          }
          // this.loading.check = false;
        })
        .catch((error) => {
          console.log(error);
          // this.loading.check = false;
        });
    },
    checkAtletByNik() {
      this.alertdata.show = false;
      if (this.check.reference !== '') {
        this.hasil.data = [];
        this.loading.check = true;
        this.axios
          .post(
            this.api + '/public/checkdata',
            qs.stringify(
              this.check,
            ),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'bearer ' + this.publickey,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.hasil.data = resdata.data;
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.check = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
            this.loading.check = false;
          });
      }
    },
    submitCheckData() {
      this.alertdata.show = false;
      if (this.$refs.formcheck.validate()) {
        // this.checkAtletByNik();
      }
    },
  },
  components: {
    Alertsp,
    InfiniteLoading,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
